export default __webpack_public_path__ + "static/media/s2.6f665a7c.png";